<template>
    <div class="payment-container">
        <div class="header-top clearfloat">
            <div class="header-body">
                <div class="logo-top box flex-center">
                    <router-link class="link" to="/" title="首页">
                        <!-- <img class="img" src="../../assets/image/logoV2.png" /> -->
                    </router-link>
                </div>
                <div class="header-title">
                    <span>收银台充值</span>
                </div>
                <div class="header-right">
                    <router-link to="/">首页</router-link>
                </div>
            </div>
        </div>
        <!-- 内容 -->
        <div class="con" style="padding-top: 55px;min-height: 100%;">
            <div class="con-body">
                <div class="con-box">
                    <div class="box-header">
                        <h3 class="mar-b-default mar-t-0" style="font-size: 18px;color: #333;">订单详情</h3>
                        <div class="clearfloat">
                            <div class="float-left">
                                <div class="mar-b-mini">
                                    <span class="float-left" style="width: 300px;">
                                        <span class="left-tag">订单号：</span>
                                        <span v-if="statusLoad === 'loading'"><i class="icon icon-loading loading-icon icon-css"></i></span>
                                        <span v-if="statusLoad !== 'loading'">{{payData.code || '-'}}</span>
                                    </span>
                                    <span class="left-tag">充值方式：</span>
                                    <span v-if="type === 'weipay'"><img src="../../assets/image/payment/payment-icon-wx.png" class="mar-r-xs">微信</span>
                                    <span v-if="type === 'alipay'"><img src="../../assets/image/payment/payment-icon-alipay.png" class="mar-r-xs">支付宝</span>
                                </div>
                                <div class="mar-bottom-10">
                                    <span class="float-left" style="width: 300px;">
                                        <span class="left-tag">收款方：</span><span>云平台</span>
                                    </span>
                                    <span class="left-tag">充值金额：</span><span>{{money | toFixed}}</span>元
                                </div>
                            </div>
                            <div class="float-right" style="line-height: 40px;" v-if="statusLoad !== 'error' && statusLoad !== 'success'">
                                <span v-if="statusLoad === 'loading'"><i class="icon icon-loading loading-icon icon-css"></i></span>
                                <span class="color-warning mar-r-mini" v-if="statusLoad !== 'loading'">
                                    <span style="font-size: 18px;">{{time}}</span>S
                                </span>
                                后交易将关闭，请及时付款！
                            </div>
                        </div>
                    </div>
                    <!-- 支付 -->
                    <div class="box-body">
                        <!-- 微信支付 -->
                        <div class="box-case case-weixin" :class="{'case-weixin': type === 'weipay', 'case-alipay': type === 'alipay'}">
                            <div class="case-head clearfloat">
                                <span class="float-left">{{statusLoad === 'success' ? '已充值：' : '扫码付款：'}}</span>
                                <span class="float-right"><span class="color-warning" style="font-size: 28px;">{{money | toFixed}}</span>元</span>
                            </div>
                            <div class="case-content">
                                <div class="content-head clearfloat text-center">
                                    <div style="display: inline-block;" v-if="type === 'weipay'">
                                        <img src="../../assets/image/payment/payment-wx.png" style="width: 38px;height: 38px;" class="float-left" alt="微信支付">
                                        <span class="content-head-title">微信支付</span>
                                    </div>
                                    <div class="text-center" v-if="type === 'alipay'">
                                        <img src="../../assets/image/payment/payment-alipay.png" alt="支付宝支付">
                                    </div>
                                </div>
                                <div class="content-qr">
                                    <div class="qr-img"><img :src="payData.qrcode"  width="100%"></div>
                                    <!-- 加载中 -->
                                    <div class="qr-loading qr-error bg-transparent" v-if="statusLoad === 'loading'">
                                        <p><i class="icon icon-loading loading-icon" style="font-size: 30px;"></i></p>
                                    </div>
                                    <!-- 失效 -->
                                    <div class="qr-error cursor-pointer" :class="{'bg-transparent-2': isLoadErr}" v-if="statusLoad === 'error'" @click="selectGetData()">
                                        <p><i class="icon icon-refresh" style="font-size: 30px;"></i></p>
                                        <p class="line-height-default">点击刷新</p>
                                    </div>
                                    <!-- 成功提示窗 -->
                                    <div class="qr-success" v-if="statusLoad === 'success'">
                                        <i class="icon icon-css icon-induce text-success"></i>
                                    </div>
                                </div>
                                <div class="content-footer text-center">
                                    <!-- 正常框 -->
                                    <div class="content-footer-normal clearfloat" style="display: inline-block;" v-if="statusLoad !== 'error' && statusLoad !== 'success'">
                                        <div class="float-left mar-r-mini">
                                            <i class="icon icon-scan" style="font-size: 32px;line-height: 32px;"></i>
                                        </div>
                                        <div class="float-left text-left" style="color: rgba(255,255,255,0.95);">
                                            <p style="line-height: 12px;margin-bottom: 4px;">打开手机{{type === 'alipay' ? '支付宝' : '微信'}}</p>
                                            <p>扫一扫继续付款</p>
                                        </div>
                                    </div>
                                    <!-- 失效框 -->
                                    <div class="content-footer-error clearfloat" v-if="statusLoad === 'error'">
                                        <p style="line-height: 12px;margin-bottom: 4px;">支付二维码{{isLoadErr ? '加载失败' : '已失效'}},</p>
                                        <p>请点击刷新继续支付</p>
                                    </div>
                                    <!-- 成功框 -->
                                    <div class="content-footer-error clearfloat" v-if="statusLoad === 'success'">
                                        <p style="padding-top: 10px;">已使用{{type === 'alipay' ? '【支付宝】' : '【微信】'}}充值{{money}}元</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="box-footer">
                            <login-footer :type="'ecp'"></login-footer>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Payment from './payment'
export default Payment;
</script>

<style lang="scss" scoped>
    @import "./payment.scss";
</style>

